
export const whiteOrgs = (state) => {
  return state.whiteOrgs
}
export const chnl = (state) => {
  return state.chnl
}
export const total = (state) => {
  return state.total
}
export const offset = (state) => {
  return state.offset
}
export const max = (state) => {
  return state.max
}
export const sort = (state) => {
  return state.sort
}
export const order = (state) => {
  return state.order
}
export default {
  whiteOrgs,
  chnl,
  total,
  offset,
  max,
  sort,
  order
}
